import * as types from "../../actionTypes";

export const get = (pageNumber = null) => {
  return {
    type: types.MANAGER_GET_OVERALL_COST_DETAIL_REQUEST,
    pageNumber
  };
};

export const getSuccess = data => {
  return {
    type: types.MANAGER_GET_OVERALL_COST_DETAIL_SUCCESS,
    payLoad: data
  };
};
export const getFailure = error => {
  return {
    type: types.MANAGER_GET_OVERALL_COST_DETAIL_FAILURE,
    error: error
  };
};
